/** Domínios ÉLLO: nunca confiar em query params para determinar o produto.
 * Substitua por REACT_APP_ELLO_*_HOST no build, se necessário.
 * Domínios não autorizam acesso; licenças e permissões são verificadas na API.
 */
const normalizeHostname = (value) => String(value || "").trim().toLowerCase().replace(/\.$/, "");
const currentHostname = () => typeof window !== "undefined" ? normalizeHostname(window.location.hostname) : "";
export const ELLO_APP_HOST = normalizeHostname(process.env.REACT_APP_ELLO_APP_HOST || "app.ellobeleza.com");
export const ELLO_PWA_HOST = normalizeHostname(process.env.REACT_APP_ELLO_PWA_HOST || "pro.ellobeleza.com");
export const isElloAppDomain = () => currentHostname() === ELLO_APP_HOST;
export const isElloPwaDomain = () => currentHostname() === ELLO_PWA_HOST;
export const ELLO_PWA_PATH = "/pwa/colaborador";
